import { cx } from 'emotion';
import { useDispatch } from 'react-redux';

import { legacyToolbarColors } from '@ezugi/constants';
import { Button } from '@ezugi/primitives';
import callIcon from '@ezugi/static/icons/add.svg';
import foldIcon from '@ezugi/static/icons/remove.svg';
import { DeviceInfo } from '@ezugi/utils';

import { useIntl } from '../../hooks/useIntl';
import { betActions } from '../../store/actions';
import { callBetsContainer, callBetsContainerMobile } from './CallBetsToolbar.css';

const intlSpec = {
  keys: {
    playLabel: 'games_ui.play',
    foldLabel: 'games_ui.fold',
  },
};

type CallBetsToolbarClasses = {
  root?: string;
  button?: {
    root?: string;
    icon?: string;
    label?: string;
  }
}

export type CallBetsToolbarProps = Readonly<{
  classes?: CallBetsToolbarClasses;
}>;

function CallBetsToolbar({ classes }: CallBetsToolbarProps) {
  const dispatch = useDispatch();

  const handleCall = () => {
    dispatch(betActions.bet.callBet());
  };

  const handleFold = () => {
    dispatch(betActions.bet.fold());
  };

  const { playLabel, foldLabel } = useIntl(intlSpec);

  return (
    <div
      data-e2e="call-bets--toolbar"
      className={classes?.root ?? cx(callBetsContainer, {
        [callBetsContainerMobile]: DeviceInfo.isHandheld,
      })}
    >
      <Button
        uppercase={true}
        label={playLabel}
        icon={callIcon}
        background={legacyToolbarColors.rebet}
        onClick={handleCall}
        data-e2e="bet-toolbar-call"
      />
      <Button
        uppercase={true}
        icon={foldIcon}
        background={legacyToolbarColors.fold}
        label={foldLabel}
        onClick={handleFold}
        data-e2e="bet-toolbar-fold"
      />
    </div>
  );
}

export default CallBetsToolbar;
